/** Human-readable application name — sourced from package.json via Vite. */
export const APP_NAME: string = __APP_NAME__;
